export enum SocialList {
  X = 'x',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  YOUTUBE = 'youtube',
  DISCORD = 'discord',
  TWITCH = 'twitch',
  TWITTER = 'twitter',
  TIKTOK = 'tiktok',
  LINKEDIN = 'linkedin',
  TELEGRAM = 'telegram',
  WHATSAPP = 'whatsapp',
  THREADS = 'threads',
  POGTV = 'pogtv'
}